// Einführungstour: 9 Stationen durch Radiocast, wiederholbar (Seitenleiste › Einführungstour).

import { useEffect, useState } from "react";
import { go } from "./ui";

const STEPS: { path: string; title: string; text: string }[] = [
  { path: "dashboard", title: "1 · Dashboard", text: "Hier siehst du auf einen Blick, was läuft, ob alle Ausgänge senden, ob die Engine den Sendeplan spielt – und was zu tun ist. Probleme stehen oben mit einem „Beheben“-Link." },
  { path: "bibliothek", title: "2 · Bibliothek & Rotation", text: "Links stehen deine Kategorien als Ordner (z. B. A Power Current, C 2021–2025). Titel per Ziehen verschieben; am Ordner unter „Rotation“ Ruhezeiten und Ziel-Anteile einstellen." },
  { path: "plan/uhren", title: "3 · Uhren", text: "Eine Uhr beschreibt eine Stunde: welche Kategorie, welcher Jingle, wo Werbung, Nachrichten oder ein Voicetrack kommt. Jede Kategorie passt in jeden Platz." },
  { path: "plan/wochenraster", title: "4 · Wochenraster", text: "Uhren auf die Woche malen – mit Saisons (z. B. Weihnachten) und Feiertagen. Speichern plant die kommende Woche neu." },
  { path: "plan/sendeplan", title: "5 · Sendeplan", text: "Der fertige Ablauf, Titel für Titel. Mit Wellenform, Übergangs-Editor (⇄) und „Auswahl erklären“. Oben steht, ob die Engine den Sendeplan spielt." },
  { path: "plan/imaging", title: "6 · Imaging & Drop-ins", text: "Pools für Jingles und Drop-ins – auch automatisch gefüllt (z. B. alles mit DROP_ im Namen) und mit Sendezeiten (z. B. nur am Wochenende)." },
  { path: "plan/voicetracking", title: "7 · Voicetracking", text: "Moderationen vorproduzieren: großer Mikro-Knopf mit Einzähler, drei Wellenform-Spuren zum Platzieren über Outro und Intro, Musik ducken." },
  { path: "verbund", title: "8 · Senderverbund", text: "Weitere Sender anlegen, die Musik eines Senders zu festen Zeiten übernehmen lassen – mit eigener Verpackung. Sendenachweis je Sender inklusive." },
];

export const startTour = () => window.dispatchEvent(new Event("rc-tour"));

export function Tour() {
  const [step, setStep] = useState<number | null>(null);
  useEffect(() => {
    const on = () => setStep(0);
    window.addEventListener("rc-tour", on);
    let done = true;
    try { done = localStorage.getItem("rc-tour-done") === "1"; } catch { /* private mode */ }
    if (!done) setStep(0);
    return () => window.removeEventListener("rc-tour", on);
  }, []);
  useEffect(() => { if (step != null) go(STEPS[step].path); }, [step]);
  if (step == null) return null;
  const finish = () => { try { localStorage.setItem("rc-tour-done", "1"); } catch { /* egal */ } setStep(null); };
  const s = STEPS[step];
  return (
    <div style={{ position: "fixed", right: 20, bottom: 20, zIndex: 90, width: 360, background: "#10241d", color: "#e6efe9", borderRadius: 14, padding: 16, boxShadow: "0 12px 40px rgba(0,0,0,.35)" }}>
      <div className="row" style={{ marginBottom: 6 }}>
        <b style={{ fontSize: 16 }}>{s.title}</b><span className="spacer" />
        <button className="iconbtn" style={{ color: "#e6efe9" }} onClick={finish} aria-label="Tour beenden">✕</button>
      </div>
      <div style={{ fontSize: 14, lineHeight: 1.45 }}>{s.text}</div>
      <div className="row" style={{ marginTop: 12, gap: 6 }}>
        <div style={{ display: "flex", gap: 4 }}>{STEPS.map((_, i) => <span key={i} style={{ width: 7, height: 7, borderRadius: "50%", background: i === step ? "#e8673c" : "#3b5b4f" }} />)}</div>
        <span className="spacer" />
        <button className="btn small" disabled={step === 0} onClick={() => setStep(step - 1)}>Zurück</button>
        {step < STEPS.length - 1 ? <button className="btn small primary" onClick={() => setStep(step + 1)}>Weiter</button> : <button className="btn small primary" onClick={finish}>Fertig</button>}
      </div>
    </div>
  );
}
